import axios from "axios";
import store from "../store";
import Vue from "vue";
import i18n from "../translations";

const defaultOptions = {
  authorize: true,
};
export function request(method, options, $type = null) {
  const localOpts = {
    ...defaultOptions,
    ...options,
  };
  let Headers = {
    "Content-Type": "application/json",
  };
  if (localOpts.authorize) {
    Headers.Authorization = `Bearer ${store.state.auth.bearer}`;
  }

  return axios({
    method,
    mode: "cors",
    data: options.data,
    url: options.url,
    params: options.params,
    Headers,
  })
    .then(
      (response) => {
        if ($type === "createOrderService") {
          if (response.data.length) {
            let doc;
            if (response.data[0].status === "E") {
              Vue.alert(
                `${i18n.t("orders.orderNotCreated")}`,
                response.data[0].message,
                "warning"
              );
            } else {
              if (response.data[0].message == "EDIT") {
                Vue.alert(
                  `${i18n.t("orders.orderUpdated")}`,
                  `${i18n.t("orders.orderThanksTitle")}`,
                  "success"
                );
              } else if (response.data[0].message == "OK") {
                Vue.alert(
                  `${i18n.t("orders.orderCreated")}`,
                  `${i18n.t("orders.orderThanksTitle")}`,
                  "success"
                );
              } else if (response.data[0].message == "CREATE") {
                Vue.alert(
                  `${i18n.t("orders.invoiceCreated")}`,
                  `${i18n.t("orders.invoiceThanksTitle")}`,
                  "success"
                );
              }
            }
          } else {
            Vue.alert(
              `${i18n.t("orders.orderCreated")}`,
              `${i18n.t("orders.orderThanksTitle")}`,
              "success"
            );
          }
        }
        return response;
      },
      (error) => {
        // Vue.notify({
        //   group: 'error',
        //   type: 'error',
        //   title: `${ i18n.t('orders.orderNotCreated')}`,
        //   text: `${ i18n.t('orders.orderNotCreatedText')}`,
        //   duration: 5000
        // });
      }
    )
    .catch((response) => {
      console.log(response);
    });
}
